export default {"src":"/_next/static/media/right-arrow.c61e5abb.svg","height":11,"width":23,"blurWidth":0,"blurHeight":0};